module.exports = __webpack_public_path__ + "static/media/logo.a3ed84c5.svg";